import * as yup from 'yup';
import {
    noRuEmailDomainValidator,
    noCiryllicCharsEmailDomainValidator,
} from '../../validators/email.validators';

export const addResponsiblePersonValidationSchema = yup.object({
    email: yup
        .string()
        .email()
        .required()
        .test(noRuEmailDomainValidator)
        .test(noCiryllicCharsEmailDomainValidator)
});
